import { fetchApi } from '@/helpers/fetchApi.js'

export default {
  state: {
    business_units: [],
    business_units_loading: false,
  },
  getters: {
    business_units: (state) => state.business_units,
  },
  mutations: {
    setBusinessUnits(state, business_units) {
      state.business_units = business_units
    },
    setBusinessUnitsLoading(state, value) {
      state.business_units_loading = value
    },
  },
  actions: {
    async fetchBusinessUnit(_, id) {
      return new Promise((resolve, reject) => {
        fetchApi(`business-units/${id}`)
          .then(resolve)
          .catch(() => reject(`Unable to fetch business_unit with id: ${id}.`))
      })
    },
    async emptyBusinessUnits({ commit }) {
      commit('setBusinessUnits', [])
    },
    async fetchBusinessUnits({ state, commit }) {
      if (state.business_units_loading) return

      commit('setBusinessUnitsLoading', true)

      try {
        const business_units = await fetchApi('business-units')

        commit('setBusinessUnits', business_units)
      } finally {
        commit('setBusinessUnitsLoading', false)
      }
    },
    async loadBusinessUnits({ state, dispatch }) {
      if (!state.business_units.length) {
        await dispatch('fetchBusinessUnits')
      }
    },
  },
}
